/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { MEGA_PROGRAMS } from '../data/programs.js'
import { ProgFitness, ProgCardio, ProgCorrective, ProgFlexibility, ProgMobility, ProgWarmCool } from './icons.jsx'

const ICONS = {
  fitness: ProgFitness,
  cardio: ProgCardio,
  corrective: ProgCorrective,
  flexibility: ProgFlexibility,
  mobility: ProgMobility,
  'warm-cool': ProgWarmCool,
}

export default function NavBar() {
  return (
    <nav className="seq-navbar">
      <div className="seq-nav-container">
        <button className="tb-burger" type="button" id="seq-burger" aria-label="منو" aria-expanded="false" aria-controls="mm">
          <span className="tb-ico tb-ico-menu">
            <img src="a/menu_100px.webp" alt="" width="40" height="40" />
          </span>
          <span className="tb-ico tb-ico-close">
            <img src="a/close-ico.webp" alt="" width="40" height="40" />
          </span>
        </button>
      </div>
    </nav>
  )
}
